import { createAction, props } from "@ngrx/store";
import { CashieringDateResponse } from "../../create-request/models/cashieringDate/CashieringDateResponse";
import { ServiceError } from "../../create-request/models/shared/ServiceError";

export const loadWithdrawalDate = createAction(
    '[AchForm-standing-auth-details - CashieringDate API Call] Load Withdrawal Date',
    props<{ completionDate: string }>()
);

export const loadWithdrawalDateSuccess = createAction(
    '[AchForm-standing-auth-details - CashieringDate API Call] Load Withdrawal Date Successfully',
    props<CashieringDateResponse>()
)

export const loadWithdrawalDateFailure = createAction(
    '[AchForm-standing-auth-details - CashieringDate API Call] Withdrawal Date NOT Loaded',
    props<ServiceError>()
)